import { createContext, useContext } from 'react';
import { Generic, GiftCard } from '../interfaces/interfaces';

export interface IGiftCardContextProps {
    showGiftCard: boolean;
    data: GiftCard;
    strings: Generic<string>;
}

const GiftCardContext = createContext<IGiftCardContextProps>({} as IGiftCardContextProps);
export { GiftCardContext };
export const useGiftCardContext = () => useContext(GiftCardContext);
